import { Helmet } from 'react-helmet-async'

interface JsonLdProps {
  /** A JSON-LD object graph (schema.org). Serialized into a script tag. */
  readonly data: Readonly<Record<string, unknown>>
}

/**
 * Injects one `<script type="application/ld+json">` block into <head> via
 * Helmet, so it is baked into the prerendered HTML. Use once per schema; a page
 * may render several <JsonLd> for distinct blocks (Breadcrumb, Article, FAQ…).
 *
 * `<` is escaped to `<` so a string value can never close the script tag
 * early (`</script>` injection). The result is still valid JSON-LD.
 */
export function JsonLd({ data }: JsonLdProps) {
  const json = JSON.stringify(data).replace(/</g, '\\u003c')
  return (
    <Helmet>
      <script type="application/ld+json">{json}</script>
    </Helmet>
  )
}
